import { FunctionComponent, useState } from 'react'
import styled from 'styled-components/macro'
import { Box, IconButton, ListItem, Divider, Typography } from '@material-ui/core'
import { MainNav } from '../nav-bar/MainNav'
import { useAuth } from 'pages/auth/hooks/useAuth'
//@ts-ignore
import { useTheme } from 'styled-components'
import { ExitToAppOutlined, Settings } from '@material-ui/icons'
import { ProfileStatus } from '../profile-status/ProfileStatus'
import { Link, useHistory } from 'react-router-dom'
import { PersonAdd, LockOutlined, VpnKey, Feedback, Person, VerifiedUser } from '@material-ui/icons'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import { useThemeSwitch } from 'hooks/theme'
import { ReactComponent as NetworkIcon } from 'icons/people.svg'
import { InviteFriendsByEmailModal } from 'pages/auth/components/invite-friends/InviteFriendsByEmailModal'
import { ReactComponent as SunIcon } from 'icons/sun.svg'
import { ReactComponent as MoonIcon } from 'icons/moon.svg'
import { useAnalytics } from 'hooks/use-analytics/useAnalytics'
import { useNotification } from 'hooks/use-notification/useNotification'
import { ReactComponent as CompanyIcon } from 'icons/company.svg'
import { Briefcase } from 'icons'
import { PartnerType } from 'common/types'
import { ReactComponent as GaugeIcon } from 'icons/usage-summary.svg'
import { ChannelsIcon } from 'common/icon-components/ChannelsIcon'
import { ThemeModal } from 'components/core/ThemeModal/ThemeModal'
import { useUpdateModePreference } from 'hooks/use-update-mode-preference/useUpdateModePreference'
import { SubscriptionLimitModal } from '../../../pages/profile/components/partner-profile/SubscriptionLimitModal'
import { NavbarDropdownMenu } from 'components/core/actions-menu/NavbarDropdownMenu'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { ModeSwitch } from 'common/atoms/ModeSwitch/ModeSwitch'
import { DEV_ONLY } from 'common/globalConstants'
import { Button } from 'common/atoms/Button/Button'
import { FilledBriefcaseIcon } from 'common/icon-components/FilledBriefcaseIcon'
import { UsageSummaryIcon } from 'common/icon-components/UsageSummaryIcon'

const StyledPersonButton = styled(PersonAdd)`
  && {
    font-size: 1.5em;
    fill: ${props => props.theme.colors.accent1};
    height: 1.25rem;
    width: 1.25rem;
  }
`

const StyledExitToAppOutlined = styled(ExitToAppOutlined)`
  && {
    font-size: 1.5em;
    fill: ${props => props.theme.colors.accent1};
    height: 1.25rem;
    width: 1.25rem;
  }
`
const StyledUserIcon = styled(Person)`
  cursor: pointer;
  && {
    font-size: 1.5em;
    fill: ${props => props.theme.colors.accent1};
    height: 1.25rem;
    width: 1.25rem;
  }
`

const StyledLockButton = styled(LockOutlined)`
  && {
    font-size: 1.5em;
    fill: ${props => props.theme.colors.accent1};
  }
`
const StyledFeedbackIcon = styled(Feedback)`
  && {
    font-size: 1.5em;
    fill: ${props => props.theme.colors.accent1};
    height: 1.25rem;
    width: 1.25rem;
  }
`

export const StyledSettingsIcon = styled(Settings)`
  && {
    font-size: 1.5em;
    fill: ${props => props.theme.colors.accent1};
    height: 1.25rem;
    width: 1.25rem;
  }
`
const StyledDivider = styled(Divider)`
  && {
    background-color: ${props => props.theme.colors.supplementary1};
    width: 100%;
  }
`

const StyledCompanyButton = styled(CompanyIcon)`
  && {
    height: 1.25rem;
    width: 1.25rem;
    fill: ${props => props.theme.colors.accent1};
    stroke: ${props => props.theme.colors.accent1};
  }
`

const StyledKeyboardArrowUpIcon = styled(KeyboardArrowUpIcon)`
  && {
    color: ${props => props.theme.colors.accent1};
  }
`

const StyledKeyboardArrowDownIcon = styled(KeyboardArrowDownIcon)`
  && {
    color: ${props => props.theme.colors.accent1};
  }
`

const StyledIconButton = styled(IconButton)`
  && {
    padding: 0.2em 0;
  }
`

const StyledGaugeIcon = styled(UsageSummaryIcon)`
  && {
    height: 1.25rem;
    width: 1.25rem;
  }
`

export const StyledPasswordIcon = styled(VerifiedUser)`
  && {
    font-size: 1.5em;
    fill: ${props => props.theme.colors.accent1};
    height: 1.25rem;
    width: 1.25rem;
  }
`

const StyledButton = styled(Button)`
  && {
    font-size: 14px;
    height: 35px;
  }
`

interface SideNavListProps {
  onMemberLogin?: () => void
  onPartnerLogin?: () => void
  toggleDrawer: (open: boolean) => void
  getProfilePercentage: number
  inviteUsersByEmail: Function
}

export const SideNavList: FunctionComponent<SideNavListProps> = ({
  onMemberLogin,
  onPartnerLogin,
  toggleDrawer,
  getProfilePercentage,
  inviteUsersByEmail
}) => {
  const {
    isAuthenticated,
    onLogout,
    backendUser,
    backendPartner,
    backendUserFunctions,
    backendUsageSummary
  } = useAuth()
  const theme = useTheme()
  const { mode, switchTheme } = useThemeSwitch()
  const { setLoadingPreference, loadingPreference } = useUpdateModePreference()
  const [isChanginMode, setIsChangingMode] = useState(false)
  const { notify } = useNotification()
  const [showInviteFriendsModal, setShowInviteFriendsModal] = useState(false)
  const history = useHistory()
  const { logEventAnalytics } = useAnalytics()
  const [showManageJobs, setShowManageJobs] = useState<boolean>(false)
  const hasJobPermission =
    backendUserFunctions?.find(userFunction => userFunction?.name === 'Create Job') ||
    backendUserFunctions?.find(userFunction => userFunction?.name === 'View Applicant')
  const hasCreateJobPermission = backendUserFunctions?.find(userFunction => userFunction?.name === 'Create Job')
  const hasDmPermission = backendUserFunctions?.find(userFunction => userFunction?.name === 'DM')
  const hasSearchPermission = backendUserFunctions?.find(userFunction => userFunction?.name === 'View Search')
  const [showJobLimitModal, setShowJobLimitModal] = useState<boolean>(false)
  const maxJobCount = backendUsageSummary?.currentJobCount >= backendUsageSummary?.totalJobs
  const partnerSuccessAdmin =
    backendUser?.username?.includes('partnersuccess+') && backendUser.username.includes('@bptn.com')
  const { isDevice } = useScreenSizes()

  return (
    <>
      {!isAuthenticated && isDevice && (
        <MainNav onMemberLogin={onMemberLogin} onPartnerLogin={onPartnerLogin} toggleDrawer={toggleDrawer} />
      )}
      {isAuthenticated && (
        <Box bgcolor={theme.colors.supplementary} width="100%">
          <NavbarDropdownMenu
            title=""
            icon={
              <ProfileStatus
                percentage={getProfilePercentage}
                avatar={backendUser?.image}
                name={backendUser?.firstName}
              />
            }
          >
            {backendUser && (
              <ListItem dense>
                <Box display="flex" flexDirection="row" alignItems="center" color={theme.colors.accent1}>
                  <StyledIconButton onClick={() => history.push('/profile')}>
                    <StyledUserIcon />
                    <Typography variant="body2">
                      <Box color={theme.colors.accent1} m="0 0.5em">
                        My Page
                      </Box>
                    </Typography>
                  </StyledIconButton>
                </Box>
              </ListItem>
            )}
            {backendPartner && (
              <ListItem dense>
                <Box display="flex" flexDirection="row" alignItems="center" color={theme.colors.accent1}>
                  <StyledIconButton onClick={() => history.push(`/company/${backendPartner.id}`)}>
                    <StyledCompanyButton />
                    <Typography variant="body2">
                      <Box color={theme.colors.accent1} m="0 0.5em">
                        {backendPartner?.type == PartnerType.Community ? 'Community Page' : 'Company Page'}
                      </Box>
                    </Typography>
                  </StyledIconButton>
                </Box>
              </ListItem>
            )}
            <ListItem dense>
              <Box display="flex" flexDirection="row" alignItems="center" color={theme.colors.accent1}>
                <StyledIconButton onClick={() => history.push('/invite')}>
                  <StyledPersonButton />
                  <Typography variant="body2">
                    <Box color={theme.colors.accent1} m="0 0.5em">
                      Invite Peeps
                    </Box>
                  </Typography>
                </StyledIconButton>
              </Box>
            </ListItem>
            <ListItem dense>
              <Box display="flex" flexDirection="row" alignItems="center" color={theme.colors.accent1}>
                <StyledIconButton onClick={() => history.push('/channel/select')}>
                  <ChannelsIcon />
                  <Typography variant="body2">
                    <Box color={theme.colors.accent1} m="0 0.5em">
                      Channels
                    </Box>
                  </Typography>
                </StyledIconButton>
              </Box>
            </ListItem>

            <ListItem dense>
              <Box display="flex" flexDirection="row" alignItems="center" color={theme.colors.accent1}>
                <StyledIconButton onClick={() => history.push('/feedback')}>
                  <StyledFeedbackIcon />
                  <Typography variant="body2">
                    <Box color={theme.colors.accent1} m="0 0.5em">
                      Feedback
                    </Box>
                  </Typography>
                </StyledIconButton>
              </Box>
            </ListItem>
            {backendPartner &&
              backendPartner?.type === 'corporate' &&
              (hasJobPermission || hasDmPermission || hasSearchPermission) && (
                <ListItem dense>
                  <Box display="flex" flexDirection="row" alignItems="center" color={theme.colors.accent1}>
                    <StyledIconButton onClick={() => history.push('/usage-summary')}>
                      <StyledGaugeIcon />
                      <Typography variant="body2">
                        <Box color={theme.colors.accent1} m="0 0.5em">
                          Usage summary
                        </Box>
                      </Typography>
                    </StyledIconButton>
                  </Box>
                </ListItem>
              )}
            {backendPartner?.type === PartnerType.Corporate && (
              <ListItem dense>
                <Box>
                  <StyledIconButton onClick={() => setShowManageJobs(!showManageJobs)}>
                    <Box display="flex" flexDirection="column" alignItems="flex-start" color={theme.colors.accent1}>
                      <Box display="flex" flexDirection="row" alignItems="center">
                        <Briefcase />
                        <Typography variant="body2">
                          <Box color={theme.colors.accent1} m="0 0.5em">
                            Manage Jobs
                          </Box>
                        </Typography>

                        {showManageJobs ? (
                          <StyledKeyboardArrowUpIcon fontSize="default" />
                        ) : (
                          <StyledKeyboardArrowDownIcon fontSize="default" />
                        )}
                      </Box>
                    </Box>
                  </StyledIconButton>
                  {showManageJobs && hasJobPermission && (
                    <Box display="flex" flexDirection="column" alignItems="flex-start">
                      {hasCreateJobPermission && (
                        <StyledButton
                          design="tertiary"
                          small
                          onClick={() => {
                            if (maxJobCount && !partnerSuccessAdmin) {
                              setShowJobLimitModal(true)
                            } else {
                              history.push('/jobs/create-job')
                            }
                          }}
                        >
                          Create New Job
                        </StyledButton>
                      )}
                      <StyledButton
                        design="tertiary"
                        small
                        onClick={() => {
                          history.push('/partner/jobs')
                          logEventAnalytics(
                            'Partner',
                            'Partner job view',
                            'mixpanel',
                            'Partner job view',
                            {
                              'User ID': backendUser?.id,
                              'Email address': backendUser?.username,
                              'Partner ID': backendPartner?.id,
                              'Company Name': backendPartner?.name,
                              'Account Type': 'Partner',
                              'Page Url': `${window.location.origin}/feed`
                            },
                            backendUser?.id,
                            {
                              $name: `${backendUser?.firstName} ${backendUser?.lastName}`,
                              $email: backendUser?.username
                            }
                          )
                        }}
                      >
                        View Jobs
                      </StyledButton>
                    </Box>
                  )}
                </Box>
              </ListItem>
            )}
            <ListItem dense>
              <Box display="flex" flexDirection="row" alignItems="center" color={theme.colors.accent1}>
                <StyledIconButton onClick={() => history.push('/account-settings')}>
                  <StyledSettingsIcon />
                  <Typography variant="body2">
                    <Box color={theme.colors.accent1} m="0 0.5em">
                      Account Settings
                    </Box>
                  </Typography>
                </StyledIconButton>
              </Box>
            </ListItem>
            {backendUser?.authType === 'creds' && (
              <ListItem dense>
                <Box display="flex" flexDirection="row" alignItems="center" color={theme.colors.accent1}>
                  <StyledIconButton onClick={() => history.push('/changePassword')}>
                    <StyledPasswordIcon />
                    <Typography variant="body2">
                      <Box color={theme.colors.accent1} m="0 0.5em">
                        Change Password
                      </Box>
                    </Typography>
                  </StyledIconButton>
                </Box>
              </ListItem>
            )}
            <StyledDivider />
            <ListItem dense>
              <Box display="flex" flexDirection="row" alignItems="center" color={theme.colors.accent1}>
                <StyledIconButton onClick={() => onLogout()}>
                  <StyledExitToAppOutlined />
                  <Typography variant="body2">
                    <Box color={theme.colors.accent1} m="0 1em">
                      Logout
                    </Box>
                  </Typography>
                </StyledIconButton>
              </Box>
            </ListItem>
            <StyledDivider />
            <ListItem dense style={{ padding: '0.7em' }}>
              <Typography variant="body2" component="span">
                <Box color={theme.colors.accent1} m="0.5em 0.6em">
                  Mode:
                </Box>
              </Typography>
              <ModeSwitch
                mode={mode == 'dark' ? 'light' : 'dark'}
                onChange={mode => {
                  switchTheme()
                }}
              />
            </ListItem>
          </NavbarDropdownMenu>
        </Box>
      )}

      <InviteFriendsByEmailModal
        inviteUsersByEmail={inviteUsersByEmail}
        notify={notify}
        backendUser={backendUser}
        show={showInviteFriendsModal}
        onClose={() => setShowInviteFriendsModal(false)}
        partnerId={backendPartner?.id}
      />
      <ThemeModal loading={loadingPreference} />
      <SubscriptionLimitModal show={showJobLimitModal} setShow={setShowJobLimitModal} subscriptionType="Jobs" />
    </>
  )
}
